import { IUserInfoMeResponseDto } from "@src/entities/user/api/interfaces/userInfoMeResponseDto";

export const getUserFirstLastName = (user: IUserInfoMeResponseDto | null) =>
  `${user?.first_name || "-"} ${user?.last_name || "-"}`;

export const getFirstLastInitials = (user: IUserInfoMeResponseDto | null) => {
  const firstLetterOfFirstName =
    user?.first_name?.charAt(0).toUpperCase() || "-";
  const firstLetterOfLastName = user?.last_name?.charAt(0).toUpperCase() || "-";

  return `${firstLetterOfFirstName}${firstLetterOfLastName}`;
};
